// extracted by mini-css-extract-plugin
module.exports =  {"section":"_2787e5dfdf--section--kWnNx","title":"_2787e5dfdf--title--kaRfy"};